import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { ImageFormats } from "../../../components/forms/libs/data/imageFormatTypes";

const initState = {
  gallaryImage: null
}

export const EditUploadImageFormData = {
  name: "EditUploadImageFormData",
  initialState: initState,
  section: [
    {
      title: "EditEventGalleryFormData",
      row: {},
      style: {
        sectionStyle: "row verticle-form",
      },
      rowGroup: [
        {
          groupLabel: "EditEventGalleryFormData", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-3",
          },
          groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
          fields: [
            {
              id: "gallaryImage",
              Field_Name: "Add New Image",
              // label: "+ Add New Image",
              fieldType: FormFieldTypes.ImageCropperForGallery,
              dataField: "gallaryImage",
              fieldSetting: {
                placeholder: "+ Add New Image",
                allowMultipleImage: false,
                acceptedImageFormats: [
                  ImageFormats.JPEG,
                  ImageFormats.JPG,
                  ImageFormats.PNG,
                ],
                isDownloadable: true,
                isPreview: false,
                // maxImageHeight: 1280, // Minimum Image Height in Pixels
                // minImageHeight: 225, // Minimum Image Height in Pixels
                // maxImageWidth: 1920, // Minimum Image Width in Pixels
                // minImageWidth: 225, // Minimum Image Width in Pixels
                minImageSizeInMB: 0, // Minimum Image size in MB
                maxImageSizeInMB: 8, // Maximum Image size in MB
                aspectRatio: 643 / 304,
                height: 304,
                width: 643,
              },
              validation: [
                { type: validationTypes.REQUIRE },
                { type: validationTypes.IMAGE },
              ],
              style: {
                containerCss:
                  "col-lg-12 col-md-12 profile-pic-upload .validation-text-fileuploader",
              },
            },
          ],
        },
      ],
    },
  ],
};